import React, { Component } from "react";
import { connect } from "react-redux";
import Education from "../components/Education";
import {
  searchSchools,
  createSchools
} from "../../../../actions/dropdowns.actions";
import { updateUserData } from "../../../../actions/user.actions";

class EducationContainer extends Component {
  constructor(props) {
    super(props);
    this.memberId = this.props.match.params.memberId;
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(data) {
    if (!this.memberId) {
      this.props.updateUserData(data, "/member/profile", "education");
    } else {
      const url = /(5|6|7|9)/.test(this.props.user.status_id)
        ? `/admin/member/${this.memberId}/moderation`
        : `/admin/member/approved/${this.memberId}/profile`;

      this.props.updateUserData(data, url, "education");
    }
  }

  render() {
    return (
      <Education
        onSubmit={this.handleSubmit}
        schools={this.props.schools}
        isLoadingSchools={this.props.isLoadingSchools}
        createSchools={this.props.createSchools}
        onSearchSchools={this.props.searchSchools}
        memberId={this.memberId}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    schools: state.dropdowns.schools,
    isLoadingSchools: state.dropdowns.isLoading,
    user: state.user.data
  };
};

const mapDispatchToProps = dispatch => ({
  searchSchools: query => dispatch(searchSchools(query)),
  createSchools: query => dispatch(createSchools(query)),
  updateUserData: (user, redirect, formName) =>
    dispatch(updateUserData(user, redirect, formName))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EducationContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/profile/containers/EducationContainer.js